import React from "react";
import { useLocation } from "react-router-dom";
import SalesPhoneHub from "./SalesPhoneHub";
import SalesPhoneMemo from "./SalesPhoneMemo";

/** Phone, tablet and laptop all get the v5 sales screens; salesPhone.scss widens them from 768 px. */
export const SalesHubResponsive = () => <SalesPhoneHub />;

/** Keyed per navigation so "+ New memo" from a finished memo starts clean. */
export const SalesMemoResponsive = () => {
  const location = useLocation();
  return <SalesPhoneMemo key={location.key || location.pathname} />;
};
